<template>
    <div class="mobile-wallets-checkout py-1">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="blue darken-1" size="30" width="2"></v-progress-circular>
        </div>
        <div v-else-if="billRefrence">
            <div>
                <div class="medium-text text-center text--text">
                    <div class="mb-2 text-center">
                        <img src="/img/paymob-kiosk-lg.png" style="height: 48px; max-height: 48px; width: auto" />
                    </div>
                    <div class="px-4 mt-5">
                        قم بالتوجه لأحد منافذ خدمات الدفع التي تظهر بالأعلى لتسديد قيمة عملية الشحن
                    </div>
                    <div class="surface2 font-weight-bold strong-text--text my-5 pa-3 text-center" style="font-size: 1.3rem; letter-spacing: 1px!important;">
                        {{billRefrence}}
                    </div>
                    <div class="px-4 mb-8">
                        <b>هام: </b> احفظ أو دون رقم العملية الذي يظهر أمامك وسلمه في منفذ الدفع واطلب منهم الدفع عبر وسيلة: <br> <b class="strong-text--text">مدفوعات متنوعة اكسبت Madfouaat Mutanouea Accept</b>
                    </div>
                </div>
            </div>
            <v-btn color="primary" block depressed @click="$emit('done')">
                <v-icon left>mdi-check</v-icon>
                <span>تم تدوين رقم عملية الدفع</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        amount: {
            required: true,
        }
    },
    data(){
        return {
            loading: false,
            billRefrence: null,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
        initPaymob(){
            if (!this.loading){
                this.loading = true;
                  
                this.$store.dispatch('createPaymobKioskOrder', {amount: this.amount}).then(response=>{
                    this.loading = false;
                    this.billRefrence = response.data.bill_reference;

                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، حاول مرة أخرى', 'error');
                })
            }
        }
    },
    mounted(){
        if (!this.billRefrence){
            this.initPaymob();
        }
    }
}
</script>

<style lang="scss">
.mobile-wallets-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}
</style>